import { BaseEntity } from '../../../models';
import { OrigemLancamentoCadastro } from '../../../models/origem-lancamento-cadastro';
import { Pessoa } from '../pessoa';
import { representanteAtivo } from './situacao';
import { Usuario } from '../../usuario/usuario';
// import { RepresentanteMarca } from './marca';
// import { RepresentanteLinha } from './linha';
import { RepresentanteVinculado } from './vinculado';
import { RepresentanteAtendente } from './atendente';
import { RepresentanteGerente } from './gerente';
import { RepresentanteClassificacaoCliente } from './classificacao-cliente';

export class Representante implements BaseEntity {
    id: number;
    origemCadastro: number;
    idPessoa: number;
    pessoa: Pessoa;
    situacao: number;
    modalidadeComercial: number;
    tipoComissao: number;
    percComissao: number;
    usuarioAvatarUrl: string;
    idUsuarioGerente: number;
    usuarioGerente: Usuario;
    gerentes: RepresentanteGerente[];
    idUsuarioAtendente: number;
    usuarioAtendente: Usuario;
    atendentes: RepresentanteAtendente[];
    anotacao: string;
    // marcas: RepresentanteMarca[];
    // linhas: RepresentanteLinha[];
    representantesVinculados: RepresentanteVinculado[];

    // Classificações de Clientes
    classificacoesClientesNome: string;
    classificacoesClientes: RepresentanteClassificacaoCliente[];

    // Importação
    tagImportacao: string;
    dataImportacao: Date;

    // Integração ERP
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: boolean;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    // Configurações
    considerarMediaGeralMeta: boolean;
    exibirRankMeta: boolean;

    constructor(origemCadastro: OrigemLancamentoCadastro) {
        this.origemCadastro = origemCadastro?.id ?? null;
        this.pessoa = new Pessoa(origemCadastro);
        this.situacao = representanteAtivo.id;
        // this.marcas = [];
        // this.linhas = [];
        this.representantesVinculados = [];
        this.gerentes = [];
        this.atendentes = [];
        this.classificacoesClientes = [];

        // Configurações
        this.considerarMediaGeralMeta = true; // Se deve considerar ou não o representante no cálculo da média geral das metas
        this.exibirRankMeta = true; // Se deve exibir ou não o representante rank das metas
    }
}
